import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DashboardService } from '../dashboard.service';
import {Location} from '@angular/common';

@Component({
    selector: 'app-single-entity',
    templateUrl: './single-entity.component.html',
    styleUrls: ['./single-entity.component.css'],
    standalone: false
})

export class SingleEntityComponent implements OnInit {

  entity: any = {};
  entityId = '';
  createdAt: any;
  subjective: any[] = [];
  environment = environment;
  ratings = [];

  constructor(private route: ActivatedRoute,
              private dashboardService: DashboardService,
              private _location: Location) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.entityId = params['id']);
    this.getCurrentEntityData();
    this.getRatingsScore();
  }

  getCurrentEntityData(): void {
    this.dashboardService.getSingleEntity(this.entityId).subscribe((data) => {
      this.entity = data;
      console.log('ENTITY', this.entity);
      this.createdAt = new Date(this.entity.createdAt).toLocaleString();
    });
  }

  getRatingsScore(): void {
    this.dashboardService.getRatingsScore(this.entityId).subscribe((data) => {
      this.ratings = data;
    });
  }

  goBack(): void{
    this._location.back();
  }
}
